import { create } from "zustand";

export interface useOnSignUpTeamMemberStoreState {
  signUpStep: number;
  setSignUpStep(signUpStep: number): void;
}

export const useOnSignUpTeamMemberStore =
  create<useOnSignUpTeamMemberStoreState>()((set) => ({
    signUpStep: 0,
    setSignUpStep: (signUpStep: number) => {
      set(() => ({ signUpStep }));
    },
  }));
